import React from "react";
import image1 from "../images/image1.jpg";
// import image2 from "../images/image2.jpg";
// import image3 from "../images/image3.jpg";
// import image4 from "../images/image4.jpg";
// import image5 from "../images/image5.jpg";
// import image6 from "../images/electrician.jpg";
// import image7 from "../images/maintainance.jpg";
// import image8 from "../images/house.jpg";
// import logo from "../images/logo.png";
import generalRepairs from "../images/generalRepairs.jpg";
import recurringService from "../images/recurringService.jpg";
import propertyPreservation from "../images/propertyPreservation.png";
import logoNoBg from "../images/logoNoBg.png";
import { Link } from "react-router-dom";
import useContentFade from "../hooks/useContentFade";

const Home = () => {
  // Content fade feature: opacity steps down 20% each day starting the day
  // after deploy (see DEPLOY_DATE in useContentFade.js), until fully faded.
  // To disable, comment out the line below and use the fallback instead.
  const fadeOpacity = useContentFade();
  // const fadeOpacity = 1; // <- uncomment this (and comment the line above) to disable the fade

  return (
    <div
      className="font-sans text-white bg-gray-900"
      style={{ opacity: fadeOpacity, transition: "opacity 1s ease" }}
    >
      {/* Hero Section */}
      <section className="relative h-screen">
        <img
          src={image1}
          alt="Hero"
          className="absolute inset-0 w-full h-full object-cover z-0"
        />
        <div className="absolute inset-0 bg-black bg-opacity-60 flex flex-col items-center justify-center text-center px-4 z-10">
          {/* <div className=" absolute top-[5px] left-[5px] md:top-[8px] md:left-[8px] ">
            <img src={logo} width={60} alt="" />
          </div> */}
          {/* <div className=" absolute top-[200px] ">
            <img src={logoNoBg} width={100} alt="" />
          </div> */}
          <div className="mb-[20px] md:mb-0">
            <img src={logoNoBg} width={100} alt="" />
          </div>
          <h1 className="text-4xl md:text-6xl font-bold mb-4">
            Winik Properties LLC
          </h1>
          <p className="text-lg md:text-xl max-w-2xl">
            Reliable care for every property, Winik Properties LLC delivers
            expert preservation and management with a personal touch.
          </p>
        </div>
      </section>

      {/* Vendor Callout Section */}
      <section className="py-12 bg-white text-black text-center">
        <h2 className="text-2xl md:text-4xl font-bold mb-2">
          Looking for the BEST vendors in the US?
        </h2>
        <p className="text-lg">
          You found us!
          <br />
          Now scroll down and check out what we have to offer!
        </p>
        {/* <div className="flex justify-center gap-4 mt-8 flex-wrap">
          {[image8, image6, image7].map((img, i) => (
            <img
              key={i}
              src={img}
              alt="Service example"
              className="rounded-lg shadow-lg h-60 object-cover w-full max-w-xs"
            />
          ))}
        </div> */}
      </section>

      {/* Property Preservation */}
      <section className="relative">
        <img
          src={propertyPreservation}
          alt="Property Preservation"
          className="w-full h-[500px] object-cover"
        />
        <div className="absolute inset-0 bg-black bg-opacity-60 flex items-center justify-center">
          <div className="text-center px-4 max-w-3xl">
            <h2 className="text-3xl font-bold mb-4">Property Preservation</h2>
            <p>
              Property preservation services maintain your vacant properties.
              Includes lock changes, inspections, lawn care, boarding, initial
              securing, final securing, debris removal, trash out, clean out,
              evictions, tree removals, and all types of landscaping works.
            </p>
          </div>
        </div>
      </section>

      {/* Recurring Services */}
      <section className="relative">
        <img
          src={recurringService}
          alt="Recurring Services"
          className="w-full h-[500px] object-cover"
        />
        <div className="absolute inset-0 bg-black bg-opacity-60 flex items-center justify-center">
          <div className="text-center px-4 max-w-3xl">
            <h2 className="text-3xl font-bold mb-4">Recurring Services</h2>
            <p>
              We provide regular mowing, edging, seasonal cleanups, and
              maintenance to keep your property clean and compliant. We provide
              initial grass cuts, grass recuts, maid refreshes, sales cleans,
              gutter cleaning, roof cleaning, etc.
            </p>
          </div>
        </div>
      </section>

      {/* General Repairs */}
      <section className="relative">
        <img
          src={generalRepairs}
          alt="General Repairs"
          className="w-full h-[500px] object-cover"
        />
        <div className="absolute inset-0 bg-black bg-opacity-60 flex items-center justify-center">
          <div className="text-center px-4 max-w-3xl">
            <h2 className="text-3xl font-bold mb-4">General Repairs</h2>
            <p>
              We handle a wide range of essential repairs including roof leaks,
              shingle replacements, light fixture installations, plumbing clogs,
              painting, and other handyman services all delivered with precision
              and care.
            </p>
          </div>
        </div>
      </section>

      {/* Contact Section */}
      <section className="relative">
        <div className="w-full h-[500px] bg-[#0f3654]"></div>
        <div className="absolute inset-0 bg-black bg-opacity-60 flex items-center justify-center">
          <div className="text-center px-4 max-w-3xl flex flex-col items-center justify-center">
            <div className="mb-[10px]">
              <img src={logoNoBg} width={80} alt="" />
            </div>
            <div>
              <h2 className="text-3xl font-bold mb-6">Get in touch!</h2>
              <p className="mb-2">
                E-mail us at:{" "}
                <a href="mailto:info@winikproperties.com" className="">
                  contact.winikproeprties@gmail.com
                </a>
              </p>
              <p className="mb-2">Call us at: +1 (727) 405 1863</p>
              <p>Location: 7901 4th St N Ste 300, St Petersburg, FL 33702</p>
              <div className="mt-6 font-semibold">Winik Properties LLC</div>
            </div>
            <Link
              to="/contact-us"
              className="flex items-center justify-center text-sm gap-4 pt-4"
            >
              Contact Us
            </Link>
            <div className="flex items-center justify-center text-sm gap-4 py-4">
              <Link to="/privacy-policy">Privacy Policy</Link>
              <div>|</div>
              <Link to="/terms-and-conditions">Terms and Conditions</Link>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Home;
